import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'app/rootReducer'
import { Redirect } from 'react-router-dom'
import {
  setIsAuthenticationFlag,
  setAccountCreationStep
} from 'reducers/authentication/authenticationSlice'
import Button from 'react-bootstrap/Button'
import { AccountCreationStep } from 'share/utils/utils'
import './styles.scss'

const NewAccountCreateBookmark = (): JSX.Element => {
  const authentication = useSelector((state: RootState) => state.authentication)
  const [toDashboard, setToDashboard] = React.useState(false)
  const dispatch = useDispatch()

  if (toDashboard === true) {
    if (authentication.account && authentication.account?.caseCount === 1) {
      return <Redirect to='/dashboard/case' />
    } else {
      return <Redirect to='/client' />
    }
  }

  const goToCaseDashboard = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    e.preventDefault()

    dispatch(setIsAuthenticationFlag(true))
    dispatch(setAccountCreationStep(AccountCreationStep.CompletedAllSteps))
    setToDashboard(true)
  }

  return (
    <div className='ui-create-bookmark-page'>
      <div className='row'>
        <div className='col-12'>
          <h2 data-testid='create-account-bookmark-heading'>
            Great! You're all set and ready to get started.
          </h2>
          <p data-testid='create-account-bookmark-description'>
            We recommend creating a bookmark on your browser to quickly access
            your case details and updates.{' '}
            <a
              href='https://www.wikihow.com/Bookmark-a-Website#'
              rel='noopener noreferrer'
              target='_blank'
              data-testid='create-account-bookmark-link'
            >
              Learn more
            </a>
          </p>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 offset-md-3 offset-lg-2 col-md-6 col-lg-8 btn-container'>
          <Button
            data-testid='create-account-bookmark-goto-dashboard-button'
            type='button'
            className='btn btn-submit w-100 mt-3'
            onClick={goToCaseDashboard}
          >
            Go To Case Dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NewAccountCreateBookmark
